export const CRM_USER_INFO = 'CRM_USER_INFO'; // 用户信息
export const CRM_CALLCENTER_INFO = 'CRM_CALLCENTER_INFO'; // 呼叫中心信息
export const CRM_All_CALLCENTER = 'CRM_All_CALLCENTER'; // 所有呼叫中心
export const CRM_TOKEN = 'CRM_TOKEN'; // 用户TOKEN
export const CRM_MENU = 'CRM_MENU'; // 用户菜单
export const SideBarMenu = 'SideBarMenu'; // 侧边栏菜单
export const CRM_FUNC_KEYS = 'CRM_FUNC_KEYS' // 功能key
export const CRM_NAVFUNC_KEYS = 'CRM_NAVFUNC_KEYS' //
export const CRM_NAVFUNC_URLS = 'CRM_NAVFUNC_URLS' // 菜单访问功能Id
export const CRM_MENU_KEYS = 'CRM_MENU_KEYS' // 菜单选中展开功能key
export const CRM_MENU_REPORT = 'CRM_MENU_REPORT' // 菜单选中展开功能key
export const CRM_SCHOOL_TYPE= 'CRM_SCHOOL_TYPE' // 用户所在校区类型

export const CRM_TEMPLATE_TYPES = 'CRM_TEMPLATE_TYPES'; // 模板类型list
export const CRM_ACTIVITY_STATUS = 'CRM_ACTIVITY_STATUS'; // 活动状态list
export const  Permanent_School_Logo = 'Permanent_School_Logo' // 学校logo
export const Headquarters_Procurement = 'Headquarters_Procurement'; // 总部采购
export const Agent_Remake = 'Agent_Remake'; // 备注
export const Agent_ID = 'Agent_ID'; // 代理商ID
export const Maintenance = 'Maintenance'; // 申请维修
export const CRM_SUBJECT = 'CRM_SUBJECT'; // 学科
export const CRM_COURSE_TYPE = 'CRM_COURSE_TYPE'; // 课程类型
export const CRM_LESSON_TYPE = 'CRM_LESSON_TYPE'; // 班级类型
export const CRM_CAMPUS_TREE = 'CRM_CAMPUS_TREE'; // 校区人员树
export const CRM_SALE_CAMPUS_TREE = 'CRM_SALE_CAMPUS_TREE'; // 签约代理商人员树
export const CRM_USER_TREE = 'CRM_USER_TREE'; // 校区人员树
export const USER_TREE = 'USER_TREE'; // 校区档案人员树

export const CRM_SUBJECTS = 'CRM_SUBJECTS'; // 学科
export const CRM_INDENTITY = 'CRM_INDENTITY'; // 身份
export const CRM_REPORTSTATUS = 'CRM_REPORTSTATUS'; // 填报状态
export const CRM_CLASSTYPE = 'CRM_CLASSTYPE'; // 班型
export const CRM_COURSETYPE = 'CRM_COURSETYPE'; // 课程类型
export const CRM_ATTENDSTATUS = 'CRM_ATTENDSTATUS'; // 出席情况
export const CRM_STUDENTTYPE_ONE = 'CRM_STUDENTTYPE_ONE'; // 学员类型一级
export const CRM_STUDENTTYPE_TWO = 'CRM_STUDENTTYPE_TWO'; // 学员类型二级


export const CRM_CHANNER = 'CRM_CHANNER'; // 渠道
export const CRM_ENDSTATUS = 'CRM_ENDSTATUS'; // 结课状态
export const CRM_STUDENT_TYPE = 'CRM_STUDENT_TYPE '; // 学员类型
export const CRM_STUDENT_LABEL = 'CRM_STUDENT_LABEL '; // 学员标签

export const Master_Use_Callphone = 'Master_Use_Callphone'; // 话机权限
export const CRM_CURRENT_TAB = 'CRM_CURRENT_TAB'; // 教务中心-学员管理-学员学情 tab当前页


export const ORDER_STATUS = 'ORDER_STATUS'; // 订单状态
export const ORDER_TYPE = 'ORDER_TYPE'; // 订单类型
export const ORDER_CLASSTYPE = 'ORDER_CLASSTYPE'; // 订单课程类型
export const ORDER_SUBJECT = 'ORDER_SUBJECT'; // 订单学科
export const ORDER_DISCOUNTS_TYPE = 'ORDER_DISCOUNTS_TYPE'; // 订单优惠类型
export const ORDER_REFUND_WAYS = 'ORDER_REFUND_WAYS'; // 订单退款方式
export const ORDER_PAYMENT = 'ORDER_PAYMENT'; // 付款方式

export const SCHOOL_CENTER_SUBJECT = 'SCHOOL_CENTER_SUBJECT'; //校长端科目
export const SCHOOL_CENTER_STAGE = 'SCHOOL_CENTER_STAGE'; //校长端阶段
export const SCHOOL_CENTER_BOOK = 'SCHOOL_CENTER_BOOK'; //校长端教材
export const SCHOOL_CENTER_GRADE = 'SCHOOL_CENTER_GRADE'; //校长端年级
export const SCHOOL_CENTER_STATUS = 'SCHOOL_CENTER_STATUS'; //校长端课程状态
export const SCHOOL_CENTER_TAG = 'SCHOOL_CENTER_TAG'; //校长端标签
export const SETTLEMENT_TPYE = 'SETTLEMENT_TPYE'; //结算状态
export const Order_Payment = 'Order_Payment'; //收费方式
export const Order_Offline_Payment = 'Order_Offline_Payment'; //线下收费
export const all_login_ture = 'all_login_ture'; // 物流


export const Add_Class = 'Add_Class'; // 新增班级
export const Edit_Class = 'Edit_Class'; // 编辑班级
export const Delete_Class = 'Delete_Class'; // 删除班级
export const Open_Class = 'Open_Class'; // 开班
export const Show_Class_Info = 'Show_Class_Info'; // 班级详情

export const RefundManage_RefundDetail = 'RefundManage_RefundDetail'; // 查看退费信息
export const OrderManage_OrderDetail = 'OrderManage_OrderDetail'; // 订单详情
export const OrderManage_Collection = 'OrderManage_Collection'; // 收款
export const RuleSet_SetAttendanceMachine = 'RuleSet_SetAttendanceMachine'; // 管理考勤机
export const RuleSet_SetClassTime = 'RuleSet_SetClassTime'; // 新增/编辑上课时间段
export const RuleSet_ClassEliminate = 'RuleSet_ClassEliminate'; // 新增/修改课消规则
export const RuleSet_AddClassroom = 'RuleSet_AddClassroom'; // 新增教室
export const RuleSet_ChangeClassType = 'RuleSet_ChangeClassType'; // 新增/编辑班级类型
export const Add_StudentLabel = 'Add_StudentLabel'; // 新增学员标签
//update by jq  use 新学员来源标签页
export const Add_StudentOriginLabel = 'Add_StudentOriginLabel'; // 新增学员来源标签

export const BehaviorRecord_Detail = 'BehaviorRecord_Detail'; // 查看操作详情
export const Self_Use = 'Self_Use'; //  付款1元
export const AccountManage_DeleteAccount = 'AccountManage_DeleteAccount'; // 删除账户
export const AccountManage_ResetPSD = 'AccountManage_ResetPSD'; // 重置密码
export const AccountManage_DisableAccount = 'AccountManage_DisableAccount'; // 禁用账户
export const AccountManage_EditAccount = 'AccountManage_EditAccount'; // 编辑已有账户信息
export const AccountManage_AddAccount = 'AccountManage_AddAccount'; // 新增账户
export const XQSJ_Export_SchoolInfo = 'XQSJ_Export_SchoolInfo'; // 导出校区数据
export const Tb_FillIn = 'Tb_FillIn'; // 填写校区详情
export const Tb_Add_Courses = 'Tb_Add_Courses'; // 新增排课信息
export const Tbbx_Add_Student = 'Tbbx_Add_Student'; // 新增线下学员
export const Tbbx_Import_Student = 'Tbbx_Import_Student'; // 导入学员信息
export const Tbbx_Export_Student = 'Tbbx_Export_Student'; // 导出学员信息

export const Monitor_Class = 'Monitor_Class'; // 监课
export const Show_Teacher_PSD = 'Show_Teacher_PSD'; // 查看/重置分析员账号密码
export const Edit_Teacher_Info = 'Edit_Teacher_Info'; // 修改分析员信息
export const Apply_Teacher_Account = 'Apply_Teacher_Account'; // 申请分析员账号
export const Add_Teacher = 'Add_Teacher'; // 新增分析员

export const Export_Punch_Record = 'Export_Punch_Record'; // 导出打卡记录
export const Change_Project = 'Change_Project'; // 转项目
export const Give_Period = 'Give_Period'; // 赠送课时
export const Apply_Refund = 'Apply_Refund'; // 申请退款
export const Show_Student_Info = 'Show_Student_Info'; // 学员管理-查看详情
export const Affirm_Arrive = 'Affirm_Arrive'; // 到店确认
export const Cancel_Invite = 'Cancel_Invite'; // 取消邀约
export const Batch_Import_Reading_Students = 'Batch_Import_Reading_Students'; // 单个导入/批量导入
export const Master_Data_Export = 'Master_Data_Export'; // 数据导出 - 单个导出/批量导出
export const Batch_Allot_CR = 'Batch_Allot_CR'; // 批量分配班主任
export const Custom_Offer = 'Custom_Offer'; //  优惠

export const Add_Purchase = 'Add_Purchase'; // 新增采购订单
export const Modify_Purchase = 'Modify_Purchase'; //  付款
export const Purchase_Payment = 'Purchase_Payment'; //  修改采购订单
export const Cancel_Purchase = 'Cancel_Purchase'; //  取消采购订单
export const Submit_Purchase = 'Submit_Purchase'; //  提交采购订单

export const Begin_Class = 'Begin_Class'; // 开课
export const Apply_Order = 'Apply_Order'; // 报名
export const CallRecordQuery_PersonnelAndCa = 'CallRecordQuery_PersonnelAndCa'; // 选择校区
export const Potential_BatchFailure = 'Potential_BatchFailure'; // 潜在学员-批量标记失效
export const Potential_Import_BatchModify = 'Potential_Import_BatchModify'; // 潜在学员导入批量修改
export const Attendance_Face = 'Attendance_Face'; // 考勤打卡-人脸识别
// export const Master_JiaoWu_ImportStu = 'Master_JiaoWu_ImportStu'; // 批量导入线索
// export const Master_JiaoWu_MarkHis = 'Master_JiaoWu_MarkHis'; // 标记在读/历史
// export const Master_Consultant = 'Master_Consultant'; // 开通校长端课程顾问角色
export const Master_Export_Recording = 'Master_Export_Recording'; // 通话录音导出
export const Master_Monitor_Callphone = 'Master_Monitor_Callphone'; // 话务监控权限
export const Mark_Students_Reading_History = 'Mark_Students_Reading_History'; // 标记在读/历史
// export const Delete_Attendance_Records = 'Delete_Attendance_Records'; // 删除考勤记录
export const Master_Headquarters_Campus = 'Master_Headquarters_Campus'; // 所属校区
export const Master_Edit_Custom = 'Master_Edit_Custom'; // 修改学员姓名
export const Master_Student_Enroll = 'Master_Student_Enroll'; // 学员报名
// export const Master_Sale_Manager = 'Master_Sale_Manager'; // 销售主管
export const Master_Sale_Member = 'Master_Sale_Member'; // 销售成员
export const Master_Remove_Student = 'Master_Remove_Student'; // 删除学员
export const CONTRACT_STATUS = 'CONTRACT_STATUS'; //合同状态
export const OPEN_INVOICE_STATUS = 'OPEN_INVOICE_STATUS'; // 订单状态
export const Cancel_Electronics_Invoice = 'Cancel_Electronics_Invoice'; // 作废电子发票
export const Open_Invoice= 'Open_Invoice_Apply'; // 开票申
export const Created_Contract= 'Created_Contract'; // 电子合同
export const Modify_Course_Type= 'Modify_Course_Type'; // 修正课程类型 恢复使用
export const Course_Product= 'Course_Product'; // 课程产品公共key
export const Erp_Give_ShareEqually= 'Erp_Give_ShareEqually'; // 赠送平摊课时金额
export const AddClass_Bound= 'AddClass_Bound'; // 课程解绑
export const AddStudent_Bound= 'AddStudent_Bound'; // 学员学习课程解绑
export const UpGradeCourse= 'UpGradeCourse'; // 学员学习课程升级
export const BigClassOrderSubject= 'BigClassOrderSubject'; // 添加大班课
export const ModifySimOrderInfo = 'ModifySimOrderInfo'; // 修改完款订单
export const AddClassStudent = 'AddClassStudent'; // 添加班级学员

export const Camera_Monitor= 'Camera_Monitor'; // 监视链接获取
export const Order_Spilt= 'Order_Spilt'; // 订单分单


export const EXCHANGE_COMMODITY = 'EXCHANGE_COMMODITY'; // 兑换商品key
export const Super_Privilege_Configuration = 'Super_Privilege_Configuration'; //小松鼠课消超级权限
export const EXPORT_IMPORT = 'EXPORT_IMPORT'; // 导出导入key
/**导出key */
export const EXPORT_SALE_POTENTIALSTUDENT= 'EXPORT_SALE_POTENTIALSTUDENT'; //  销售中心-学员档案-在读学员
export const EXPORT_SALE_READINGSTUDENT= 'EXPORT_SALE_READINGSTUDENT'; //  销售中心-学员档案-在读学员
export const EXPORT_SALE_HISTORYSTUDENT= 'EXPORT_SALE_HISTORYSTUDENT'; // 销售中心-学员档案-历史学员
export const EXPORT_SALE_AUDITION_CLASS= 'EXPORT_SALE_AUDITION_CLASS'; // 销售中心-邀约管理-试听课
export const EXPORT_SALE_INVITATION_STORE= 'EXPORT_SALE_INVITATION_STORE' //销售中心-邀约管理-邀约到店
export const EXPORT_SALE_MAA_AUDITION= 'EXPORT_SALE_MAA_AUDITION' //销售中心-邀约管理-预约试听
export const EXPORT_SALE_ME_REPORT= 'EXPORT_SALE_ME_REPORT'; // 销售中心-知识漏洞体检-体检报告
export const EXPORT_SALE_ME_EG= 'EXPORT_SALE_ME_EG'//销售中心-知识漏洞体检-体检测评组
export const EXPORT_SALE_INVITATION_HEOKL= 'EXPORT_SALE_INVITATION_HEOKL'//销售中心-知识漏洞体检-邀约知识漏洞大体检
export const EXPORT_SALE_HS_POOL= 'EXPORT_SALE_HS_POOL'; // 销售中心-公海池
export const EXPORT_FIN_ORDER_MANAGE= 'EXPORT_FIN_ORDER_MANAGE'; // 财务中心-订单管理
export const EXPORT_FIN_CONSUME_RECORDS= 'EXPORT_FIN_CONSUME_RECORDS'; //  财务中心-电子账户-消费记录
export const EXPORT_FIN_RECHARGE_RECORDS= 'EXPORT_FIN_RECHARGE_RECORDS'; //  财务中心-电子账户-充值记录
export const EXPORT_FIN_SWEAT_RECORDS= 'EXPORT_FIN_SWEAT_RECORDS'; //  财务中心-电子账户-退转记录
export const EXPORT_FIN_INVOICE_RECORDS= 'EXPORT_FIN_INVOICE_RECORDS'; //  财务中心-电子账户-开票记录
export const EXPORT_FIN_REFUND_LIST= 'EXPORT_FIN_REFUND_LIST'; //  财务中心-学员退费-退款列表
export const EXPORT_EA_READINGSTUDENT= 'EXPORT_EA_READINGSTUDENT'; //  教务中心-学员管理-在读学员
export const EXPORT_EA_HISTORYSTUDENT= 'EXPORT_EA_HISTORYSTUDENT'; //  教务中心-学员管理-历史学员
export const EXPORT_EA_ACTIVITYSTUDENT= 'EXPORT_EA_ACTIVITYSTUDENT'; //  教务中心-学员管理-活动学员
export const EXPORT_EA_CLASS= 'EXPORT_EA_CLASS'; //  教务中心-班级管理-班课
export const EXPORT_EA_TEACHER_TIMETABLE= 'EXPORT_EA_TEACHER_TIMETABLE'; //  教务中心-校区课表-分析员课表
export const EXPORT_EA_STUDENT_TIMETABLE= 'EXPORT_EA_STUDENT_TIMETABLE'; //  教务中心-校区课表-学员课表
export const EXPORT_EA_CLASS_RECORDS= 'EXPORT_EA_CLASS_RECORDS'; //  p023 教务中心-学员智适应记录-课程上课记录
export const EXPORT_EA_CANCELLATION_STATEMET= 'EXPORT_EA_CANCELLATION_STATEMET'; //   教务中心-学员智适应记录-课时课消对账单
export const EXPORT_EA_STUDENT_SITUATION= 'EXPORT_EA_STUDENT_SITUATION'; //    教务中心-学员智适应记录-学员学情
export const EXPORT_EA_TOPIC_DETAILED= 'EXPORT_EA_TOPIC_DETAILED'; //    教务中心-学员智适应记录-知识点明细
export const EXPORT_EA_CLASSTIME_WARNING= 'EXPORT_EA_CLASSTIME_WARNING'; //    教务中心-智适应课时预警
export const EXPORT_TS_TEACHER_MANAGE= 'EXPORT_TS_TEACHER_MANAGE'; //    教学中心-分析员管理
export const EXPORT_TS_TEACHING_LIST= 'EXPORT_TS_TEACHING_LIST'; //    教学中心-教学质检-分析员授课列表
export const EXPORT_TS_SUPER_SP_CLASS= 'EXPORT_TS_SUPER_SP_CLASS'; //    教学中心-超级监课
export const EXPORT_TS_BKMK= 'EXPORT_TS_BKMK'; //    教学中心-备课磨课
/**end */
export const EXPORT_DELETE= 'EXPORT_DELETE'; //   导出导入-删除
export  const  TemporaryReStudy = 'TemporaryReStudy';  //临时重学
export  const Buy_ClassHours = 'Buy_ClassHours';  //课时池购买课时
export const Retreat_ClassHours = 'Retreat_ClassHours'; //课时池课时退费

export  const  CRM_PHONE_MASK = 'CRM_PHONE_MASK';  //手机号掩码
export  const  hantianCallSystemKey = 'hantianCallSystemKey';//汉天话务功能key
export  const  yixunCallSystemKey = 'yixunCallSystemKey';//易迅话务功能key

export  const  CRM_GRADE = 'CRM_GRADE';//学员年级 grade
export  const  BatchClassPackMenu = 'BatchClassPackMenu';  //批量购买课时包页面
export  const  BatchClassPack = 'BatchClassPack';  //批量购买课时包
export  const  BatchSetStartTime = 'BatchSetStartTime'; //批量设置时间段
export  const  BatchSetStopLesson = 'BatchSetStopLesson'; // 批量设置停课
export  const  ARER_TREE= 'ARER_TREE'; // 省市区联动树形接结构
export  const  ARER_TREE_CITY= 'ARER_TREE_CITY'; // 省市联动树形接结构
export const Result_Export = 'Result_Export'; //教务教学-学员服务管理-学员成绩-导出
export const Set_As_A_Case = 'Set_As_A_Case'; //教务教学-学员服务管理-学员成绩-设为案例
export const Set_Case_Rank = 'Set_Case_Rank'; //学员案库-案例管理-上榜


export  const  ViewMySchool = 'ViewMySchool'; // 我的校区档案


export  const  DingExportStudent = 'DingExportStudent'; // 钉钉学员导出
export  const  DingAddNewStudent = 'DingAddNewStudent'; // 钉钉学员新增
export  const  DingDeleteStudent = 'DingDeleteStudent'; // 钉钉学员删除

export  const  DingExportClass = 'DingExportClass'; // 钉钉班级导出
export  const  DingAddNewClass = 'DingAddNewClass'; // 钉钉班级新增
export  const  DingDeleteClass = 'DingDeleteClass'; // 钉钉班级删除
//进销存项目
export const purchaseExport = 'purchaseExport' //采购单导出
export const purchaseInfoExport = 'purchaseInfoExport'//发货信息导出
export const purchaseImport = 'purchaseImport'//发货信息导入
export const ModifyAgent = 'ModifyAgent' //修改代理商
export const ActivateAccount = 'ActivateAccount' //激活账户
export const ChangeBindPhone = 'ChangeBindPhone' //手机号换绑
export const BatchAddDistributor = 'BatchAddDistributor' //增加分销商
export const IsHasDistributor = 'IsHasDistributor' //分销商权限
export const Logistics_Details_Type = 'Logistics_Details_Type' //分销商详情
export const OnFinish_Type = 'onFinish_Type' // 11
export const SubscribeScience = 'SubscribeScience' //订阅学科管理
export const Analyst_User = 'Analyst_User'

// 是否是公校项目登录
export const PT_SCHOOL_LOGIN = 'pt-school-login';
// 入公校项目路由
export const PT_ROUTE = 'pt_route';

export const SSO_CAMPUS_INFO = 'sso_campus_info';

export const SSO_LOGIN_INFO = 'sso_login_info';

export const ACCOUNT_UPGRADE = 'accountUpgrade';























